export default __webpack_public_path__ + "static/media/cross-icon.5a757e5d.svg";